import React from "react";

const MAP = {
  Approved: "bg-sambiva-green/12 text-sambiva-green",
  Pending: "bg-sambiva-yellow/25 text-[#8a6d00]",
  Rejected: "bg-sambiva-red/12 text-sambiva-red",
  Received: "bg-blue-100 text-blue-700",
  "On route": "bg-sambiva-yellow/25 text-[#8a6d00]",
  Completed: "bg-sambiva-green/12 text-sambiva-green",
  "On hold": "bg-orange-100 text-orange-700",
  Cancelled: "bg-sambiva-red/12 text-sambiva-red",
  New: "bg-blue-100 text-blue-700",
  Read: "bg-gray-100 text-gray-600",
  Replied: "bg-sambiva-green/12 text-sambiva-green",
  Closed: "bg-gray-100 text-gray-500",
  Sent: "bg-sambiva-green/12 text-sambiva-green",
  Queued: "bg-sambiva-yellow/25 text-[#8a6d00]",
  Failed: "bg-sambiva-red/12 text-sambiva-red",
};

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-full ${MAP[status] || "bg-gray-100 text-gray-600"}`}>
      {status}
    </span>
  );
}
